/** 滑块轨道边框色 */
export const TAC_SLIDER_TRACK_BORDER_COLOR = "#e91e8c";

/** 滑块轨道已滑过区域填充色 */
export const TAC_SLIDER_TRACK_FILL_COLOR = "rgba(233, 30, 140, 0.35)";

/** 滑块按钮填充色（覆盖 TAC 默认绿色按钮图） */
export const TAC_SLIDER_BTN_COLOR = "#e91e8c";

/** 滑块轨道高度（px），默认 32 */
export const TAC_SLIDER_HEIGHT_PX = 24;

/**
 * 弹框底部留白（px）。
 * 正数增大容器高度；负数仅压缩滑块下方 margin，不会裁切内容。
 */
export const TAC_BOTTOM_GAP_PX = -20;

/** 弹框宽度（px），对应 #tianai-captcha-parent */
export const TAC_DIALOG_WIDTH_PX = 318;

/** 弹框高度（px）；0 表示按内容自动计算 */
export const TAC_DIALOG_HEIGHT_PX = 0;

/** 左下角 logo 高度（px） */
export const TAC_LOGO_HEIGHT_PX = 32;

/** 左下角 logo 宽度（px）；0 表示按高度等比缩放 */
export const TAC_LOGO_WIDTH_PX = 0;

/** 左下角 logo 相对底部栏水平中线的垂直偏移（px）；正数下移，负数上移 */
export const TAC_LOGO_CENTER_OFFSET_PX = -3;

/** 底部栏（logo / 刷新 / 关闭）距上方间距（px） */
export const TAC_SLIDER_BOTTOM_MARGIN_TOP_PX = 2;
